// Runs work that can wait (secondary maps, thumbnails) once the page has loaded and the browser is
// idle, so it never competes with the page's first paint or input
export function whenIdle(callback, { timeout = 3000 } = {}) {
  const schedule = () => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => callback(), { timeout })
    } else {
      setTimeout(callback, 200)
    }
  }

  if (document.readyState === "complete") {
    schedule()
  } else {
    addEventListener("load", schedule, { once: true })
  }
}
